const AI_AGENT_KB_CUSTOMIZATION = "ai-agent-knowledge-base:customization";

type AiAgentKnowledgeBaseQueryKeys = {
    customization: () => readonly string[];
};

export const aiAgentKnowledgeBaseQueryKeys: AiAgentKnowledgeBaseQueryKeys = {
    customization: (): readonly string[] => [AI_AGENT_KB_CUSTOMIZATION],
};
